<template>
    <div class="myTable">
        <div class="searchNav" >
            <el-button class="newAdd" type="primary" @click="showAdd" icon="el-icon-plus" v-if="$can('dictInfo:add')">新增字典</el-button>
            <span><span class="searchNameStyle">名称 ：</span><el-input v-model="searchInfo.value" clearable style="width: 300px;"  placeholder="请输入"></el-input></span>

            <span><span class="searchNameStyle">类型 ：</span>
                  <el-select v-model="searchInfo.description" clearable placeholder="请选择" @change="pageInfo">
                    <el-option
                            v-for="item in dictList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value">
                    </el-option>
                  </el-select>
            </span>
            <el-button type="primary" @click="pageInfo" style="float: right; position: relative;left: -20px;" >搜索</el-button>
        </div>
        <div class="tableStyle">
            <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick" >
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column prop="description" label="类型"></el-table-column>
                <el-table-column prop="value" label="名称"></el-table-column>
                <el-table-column prop="sortOrder" label="排序"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
<!--                <el-table-column prop="updateTime" label="处理时间"></el-table-column>-->
                <el-table-column
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="$can('dictInfo:view')"  @click="showInfo(scope.row)">详情</el-button>
                        <el-button type="text" size="small" v-if="$can('dictInfo:edit')" @click="editProduct(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" v-if="$can('dictInfo:remove')" @click="confirmRemove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
                <!-- 自定义空数据展示 -->
                <template slot="empty">
                    <div class="empty-container">
                        <el-empty :image-size="200"></el-empty>
                    </div>
                </template>
            </el-table>
            <el-pagination style="text-align: right;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="searchInfo.pageSize"
                    :page-sizes="[10,20, 50, 100]"
                    layout="sizes, prev, pager, next ,total"
                    :total="total">
            </el-pagination>
        </div>
        <div>
            <el-dialog
              :title="dialogTitle"
              :closeOnClickModal="false"
                    :visible.sync="dialogVisible"
                    width="50%"
                    :before-close="handleClose"
                    center>
                <el-form label-width="100px">
                    <el-row :gutter="20">
<!--                        <el-col :span="12">-->
<!--                            <el-form-item label="代码：">-->
<!--                                <el-input v-model="addInfo.code" placeholder="请输入"  clearable></el-input>-->
<!--                            </el-form-item>-->
<!--                        </el-col>-->
                        <el-col :span="12">
                            <el-form-item  label="类型：">
                                <el-select v-model="addInfo.description" clearable placeholder="请选择">
                                    <el-option
                                            v-for="item in dictList"
                                            :key="item.value"
                                            :label="item.value"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="字典名称：">
                                <el-input  v-model="addInfo.value" placeholder="请输入"   clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="排序：">
                                <el-input  v-model="addInfo.sortOrder" placeholder="请输入"  clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">

                        </el-col>
                    </el-row>
                </el-form>
<!--                <div class="addInfoStyle">-->
<!--                    <div>-->
<!--                        <span>代码：</span><el-input v-model="addInfo.code" placeholder="请输入" style="width: 400px;" clearable></el-input>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <span>字典名称：</span><el-input  v-model="addInfo.value" placeholder="请输入"  style="width: 400px;" clearable></el-input>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <span v-if="typeof (addInfo.id) === 'undefined'"><span >类型：</span><el-input  v-model="addInfo.description" placeholder="请输入"  style="width: 400px;" clearable></el-input></span>-->
<!--                        <span v-else ><span>类型 ：</span>-->
<!--                              <el-select v-model="addInfo.description" clearable placeholder="请选择" @change="pageInfo">-->
<!--                                <el-option-->
<!--                                        v-for="item in dictList"-->
<!--                                        :key="item.myValue"-->
<!--                                        :label="item.myValue"-->
<!--                                        :value="item.myValue">-->
<!--                                </el-option>-->
<!--                              </el-select>-->
<!--                        </span>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <span>排序：</span><el-input  v-model="addInfo.sortOrder" placeholder="请输入"  style="width: 400px;" clearable></el-input>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div style="clear: both;"></div>-->
                <div slot="footer" class="dialog-footer" style="text-align: center;">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <div>
            <el-dialog
                    title="字典详情"
                    :visible.sync="showInfoDialogVisible"
                    width="50%"
                    center>
                <el-form label-width="100px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="代码：">
                                {{addInfo.code}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="字典名称：">
                                {{addInfo.value}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="类型：">
                                {{addInfo.description}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="排序：">
                                {{addInfo.sortOrder}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-dialog>
        </div>

    </div>

</template>

<script>
    import {axios} from "../../config/axios";
    export default {
        name: "dev-info",
        data () {
            return {
                total:1,
                tableData: [],
                loading: false,
                fromLoading: false,
                currentPage:1,
                searchInfo:{
                    code:'',
                    value:'',
                    description:'',
                    pageNumber:1,
                    pageSize:50,
                },
                dialogVisible: false,
                showInfoDialogVisible: false,
                dialogVisibleUs: false,
                dialogTitle:"新增字典",
                addInfo:{
                    code:'',
                    value:'',
                    description:'',
                    sortOrder:'',
                },
                addInfoUs:{
                    dictId:'',
                    locale:'',
                    value:'',
                },
                dictList:[] //字典列表
            }
        },
        created: function () {
            this.pageInfo();
            this.getDictList();
        },
        watch: {
            'searchInfo.value'(newVal,oldVal){
                console.info(newVal,oldVal)
                if ("" == newVal){
                    this.pageInfo();
                }
            },
            'searchInfo.description'(newVal,oldVal){
                console.info(newVal,oldVal)
                if ("" == newVal){
                    this.pageInfo();
                }
            },
            'addInfo.description'(newVal,oldVal){
                this.dictList.forEach(item=>{
                    if (item.value == newVal){
                        this.addInfo.code = item.key;
                    }
                })

            },
        },
        methods:{
      //改为全局方法
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchInfo.pageNumber = val ;
                this.pageInfo();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.currentPage = 0;
                this.searchInfo.pageSize = val ;
                this.pageInfo();
            },
            handleClose(done) {  // 弹出框点击右上角的 X 隐藏弹出框
                this.clearObj(this.addInfo); // 清空新增数据
                done();
            },
            handleCloseUS(done) {  // 弹出框点击右上角的 X 隐藏弹出框
                done();
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            imageHandleAvatarSuccess(res, file) {
                if (res.code == 200){
                    this.addInfo.coverUrl=res.data;
                } else {
                    this.Message.error("图片上传失败")
                }
            },
            validate(){

                let flag = true;
                let msg  = "";
                if(this.addInfo.value === ""){
                    flag = false;
                    msg = " 名称不能为空 "
                }
                return {code:flag,msg:msg}
            },
            showAdd(){
                this.dialogVisible = true;
                this.addInfo={
                    code:'',
                    value:'',
                    description:'',
                    sortOrder:'',
                }
            },
            editStatus(){
                if (typeof (this.addInfo.id) === "undefined"){ // 新增
                    return false;
                }else {
                    return true;
                }
            },
            save(){
                if (this.fromLoading){
                    return;
                }
                this.fromLoading = true;
                let validateObj = this.validate();
                if (validateObj.code){
                    if (typeof (this.addInfo.id) === "undefined"){ // 新增
                        axios.post('/dict',this.addInfo).then(result => {
                            this.dialogVisible = false;
                            if (result.code !== 200){
                                console.log(result);
                            }
                            this.pageInfo();
                            this.clearObj(this.addInfo); // 清空新增数据
                            this.fromLoading = false;
                        }).catch(err => {
                            console.log(err);
                            this.fromLoading = false;
                        });
                    } else { // 编辑
                        axios.put('/dict',this.addInfo).then(result => {
                            this.dialogVisible = false;
                            if (result.code !== 200){
                                console.log(result);
                            }
                            this.pageInfo();
                            this.clearObj(this.addInfo); // 清空新增数据
                            this.fromLoading = false;
                        }).catch(err => {
                            console.log(err);
                            this.fromLoading = false;
                        });
                    }
                }else{
                    this.msg(validateObj.msg);
                    this.fromLoading = false;
                }
            },
            saveUs(){
                if (typeof (this.addInfoUs.id) === "undefined" || this.addInfoUs.id == ""){
                    this.addInfoUs.dictId = this.addInfo.id;
                    this.addInfoUs.locale="US";
                }
                axios.put('/dict/local',this.addInfoUs).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.clearObj(this.addInfoUs); // 清空新增数据
                    this.dialogVisibleUs = false;
                }).catch(err => {
                    console.log(err);
                    this.dialogVisibleUs = false;
                });
            },
            showUsInfo(local) {
                this.dialogVisibleUs = true;
                let params = {
                    dictId:this.addInfo.id,
                    language:local
                }
                this.clearObj(this.addInfoUs); // 清空新增数据
                axios.get('/dict/local',{
                    params: params
                }).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    let resultData = result.data;
                    if (resultData != null){
                        this.addInfoUs= resultData;
                    }
                }).catch(err => {
                    console.log(err);
                });

            },
            editProduct(obj){
                this.dialogVisible = true;
                this.dialogTitle = "编辑字典";
                this.addInfo = JSON.parse(JSON.stringify(obj));
            },
            showInfo(obj){
                this.showInfoDialogVisible = true;
                this.addInfo = JSON.parse(JSON.stringify(obj));
            },
            handleRowDblClick(row, column, event) {

                this.addInfo =JSON.parse(JSON.stringify(row));
                this.showInfoDialogVisible = true;
            },
            remove(id){
                axios.delete('/dict',{data: {dictId:id}}).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.pageInfo();
                })
            },
            confirmRemove(obj){
                this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.remove(obj);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            pageInfo(){
                if (this.loading)  return; // 防止重复提交
                this.loading=true;
                axios.get('/dict',{
                    params: this.searchInfo
                }).then(result => {
                    this.loading=false;
                    if (result.code !== 200){
                        console.log(result);
                    }
                    let page = result.data;
                    this.total = page.total;
                    this.tableData = page.list;
                }).catch(err => {
                    console.log(err);
                    this.loading=false;
                });
            },
            getDictList(){
                axios.get('/dict/allList',{
                    params: {}
                }).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.dictList = result.data;
                }).catch(err => {
                    console.log(err);
                });
            },
        },filters: {
            showState(val){
                if (val){
                    return "启动";
                }
                return "关闭"
            },
            consumerState(val){
                if (val){
                    return "禁用";
                }
                return "开启"
            }
        }
    }
</script>
<style lang="less" scoped>
    .addInfoStyle div{
        line-height: 4;
        .el-input{
            margin-right: 15px;
            width: 200px;
        }
    }
    .usBt{
        color: #409eff;
        border-bottom: 1px solid #409eff;
        cursor: pointer;
    }
</style>
